import { render, staticRenderFns } from "./ChooseSalesMan.vue?vue&type=template&id=0ca806c8&scoped=true&"
import script from "./ChooseSalesMan.vue?vue&type=script&lang=js&"
export * from "./ChooseSalesMan.vue?vue&type=script&lang=js&"
import style0 from "./ChooseSalesMan.vue?vue&type=style&index=0&id=0ca806c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca806c8",
  null
  
)

export default component.exports